<template>
    <div v-if="brands && brands.length">
        <div class="mb-md-5">
            <template v-if="header">
                <h4 class="mt-0 filter-subtitle">Marcas</h4>
                <hr class="sidebar-categories-spacer">
            </template>
            <div class="form-check mb-3" v-for="item in list_brands" :key="item.id">
                <input class="form-check-input" type="checkbox" :value="item.id" :id="'filter_brand' + item.id" v-model="filter_brands" @change="change_filter_brand($event)">
                <label class="form-check-label filter-option-name" :for="'filter_brand' + item.id">
                    {{ item.name }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import ecommerce_products_filters from "~/mixins/ecommerce_products_filters";

export default {
    props: {
        brands: {
            default: () => []
        },
        header: {
            default: true
        }
    },
    mixins: [
        ecommerce_products_filters
    ]
}
</script>
